import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "app-confirm-msg" }

import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    title: { default: '확인' },
    message: { default: '' },
    confirmText: { default: '확인' },
    cancelText: { default: '취소' },
    alertOnly: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const titleId = computed(() => 'app-confirm-title')

const onBackdrop = () => {
  if (props.alertOnly) {
    onConfirm()
    return
  }
  onCancel()
}

const onConfirm = () => {
  emit('update:modelValue', false)
  emit('confirm')
}

const onCancel = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

/** 우측 상단 X — 배경 탭과 동일 (알림은 확인, 확인창은 취소) */
const onX = () => {
  if (props.alertOnly) {
    onConfirm()
    return
  }
  onCancel()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "app-confirm-mask",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": titleId.value,
          onClick: _withModifiers(onBackdrop, ["self"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["app-confirm-card", { 'is-alert-only': __props.alertOnly }])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "app-confirm-x",
              "aria-label": "닫기",
              onClick: onX
            }, [
              _createVNode(AppIcon, {
                name: "close",
                size: 16
              })
            ]),
            _createElementVNode("h2", {
              id: titleId.value,
              class: "app-confirm-title"
            }, _toDisplayString(__props.title), 9, _hoisted_2),
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["app-confirm-actions", { 'is-single': __props.alertOnly }])
            }, [
              (!__props.alertOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "app-confirm-btn app-confirm-btn--cancel",
                    onClick: onCancel
                  }, _toDisplayString(__props.cancelText), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "app-confirm-btn app-confirm-btn--ok",
                onClick: onConfirm
              }, _toDisplayString(__props.confirmText), 1)
            ], 2)
          ], 2)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})